import { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import {
  FLASH_OFFER_URL,
  useIsSpecialOfferBannerActive,
} from './isSpecialOfferActive';

const useStyles = createUseStyles((theme: Theme) => ({
  banner: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,

    backgroundColor: theme.colors.inkPrimary,
    zIndex: 1,

    display: 'flex',
    justifyContent: 'center',
    padding: theme.marginBase * 2,
  },
  spacer: {
    height: theme.marginBase * 6,
    width: '100%',
  },
  content: {
    width: '100%',
    maxWidth: 968,
  },
  firstLine: {
    ...theme.fonts.h5,
    color: theme.colors.white,
  },
  oneLine: {
    textAlign: 'center',
  },
  secondLine: {
    ...theme.fonts.caption,
    color: theme.colors.white,
  },
  link: {
    color: theme.colors.white,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
}));

export const SpecialOfferBanner = () => {
  const classes: any = useStyles();
  const { i18n } = useTranslation();
  const isSpecialOfferActive = useIsSpecialOfferBannerActive();
  const components = useMemo(
    () => ({
      a: <span className={classes.link} />,
    }),
    [classes],
  );

  if (!isSpecialOfferActive) {
    return null;
  }

  const oneLine = !i18n.exists('billing.specialOffer.banner.secondLine');

  return (
    <>
      <div className={classes.spacer} />
      <Link
        className={classes.banner}
        to={FLASH_OFFER_URL}
        target={FLASH_OFFER_URL.startsWith('http') ? '_blank' : undefined}
      >
        <div className={classes.content}>
          <div
            className={classNames(classes.firstLine, {
              [classes.oneLine]: oneLine,
            })}
          >
            <Trans
              i18nKey="billing.specialOffer.banner.firstLine"
              components={components}
            />
          </div>
          {!oneLine && (
            <div className={classes.secondLine}>
              <Trans
                i18nKey="billing.specialOffer.banner.secondLine"
                components={components}
              />
            </div>
          )}
        </div>
      </Link>
    </>
  );
};
